const TENANT_SESSION_KEY = "tenantSession";

export const setTenantSession = (data) => {
  localStorage.setItem(TENANT_SESSION_KEY, JSON.stringify(data));
}

export const getTenantSession = () => {
  const data = localStorage.getItem(TENANT_SESSION_KEY);
  if (data) {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
  return null;
}

export const removeTenantSession = () => {
  localStorage.removeItem(TENANT_SESSION_KEY);
}

export const isTenantSessionValid = () => {
  const session = getTenantSession();
  if (!session?.expires_at) return false;
  return new Date(session.expires_at) > new Date();
}
